module.exports = __webpack_public_path__ + "media/images/recipes/gemarineerde_filetlap-3637763829837009ac2c9e2b3757d10c.pdf";